import { useCallback } from 'react';
import { Progress, Tag } from 'antd';
import { STOCK_LEVEL_COLORS, getStockLevel } from '../../constants';

export const useStockLevelRender = () => {
  return useCallback((currentStock: number, record: any) => {
    const minStock = Number(record.min_stock) || 0;
    const maxStock = Number(record.max_stock) || 100;

    // Calculate percentage based on min-max range
    const percentage = Math.min(
      Math.max(((currentStock - minStock) / (maxStock - minStock)) * 100, 0),
      100
    );

    // Use the utility function to determine stock level
    const level = getStockLevel(currentStock, minStock, maxStock);
    const color = STOCK_LEVEL_COLORS[level];
    const strokeColor = color;

    return (
      <div style={{ minWidth: '160px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '4px',
          }}
        >
          <span style={{ fontWeight: 500, color: '#262626' }}>
            {Number(currentStock).toFixed(0)}
          </span>
          <Tag
            color={color}
            style={{
              fontSize: '10px',
              fontWeight: 500,
              margin: 0,
            }}
          >
            {level}
          </Tag>
        </div>
        <Progress
          percent={percentage}
          strokeColor={strokeColor}
          trailColor="#f0f0f0"
          size="small"
          showInfo={false}
          style={{ margin: 0 }}
        />
        <div
          style={{
            fontSize: '11px',
            color: '#8c8c8c',
            marginTop: '2px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <span>Min: {minStock}</span>
          <span>Max: {maxStock}</span>
        </div>
      </div>
    );
  }, []);
};
